import React from "react";
import { Flex, Typography, Badge } from "antd";
import { TEXT } from "../../GroupSkillsProficiencyV2.constants";
import {
  LegendRowStyled,
  LegendItemGroupStyled,
  LegendRequiredCaretIconStyled,
  LegendHintTextStyled,
} from "./ProficiencyColumnTitle.styles";

const { Text } = Typography;

const ProficiencyColumnTitle = ({ viewType = "group" }) => (
  <Flex vertical gap={5}>
    <span style={{ textTransform: "uppercase" }}>
      {viewType === "employee" ? TEXT.COL_CURRENT_AND_REQUIRED : TEXT.COL_INFERRED_PROFICIENCY}{" "}
      <Text type="secondary">{TEXT.COL_PROFICIENCY_SCALE}</Text>
    </span>

    {/* Flex props: align-items + gap. styled adds typography tokens. */}
    <LegendRowStyled align="center" gap={12}>

      {/* align="center" passed directly — no $top prop needed */}
      <LegendItemGroupStyled align="center" gap={6}>
        <Badge color="#007bff" />
        <span>{TEXT.COL_CURRENT_LABEL}</span>
      </LegendItemGroupStyled>

      {/* align="flex-start" aligns the icon with the top line of the text */}
      <LegendItemGroupStyled align="flex-start" gap={6}>
        <LegendRequiredCaretIconStyled />
        <span>
          {TEXT.COL_REQUIRED_LABEL}{" "}
          <LegendHintTextStyled type="secondary">
            {TEXT.COL_REQUIRED_HINT}
          </LegendHintTextStyled>
        </span>
      </LegendItemGroupStyled>

    </LegendRowStyled>
  </Flex>
);

export default ProficiencyColumnTitle;
